module.exports = __webpack_public_path__ + "img/BDCIcon4.e87ab871.png";